import { forwardRef, type Ref, type SVGProps } from "react";

function SvgPlus(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg ref={ref} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20" {...props}>
      <path
        fill="currentColor"
        d="M10 17.5a.625.625 0 0 1-.625-.625v-6.25h-6.25a.625.625 0 1 1 0-1.25h6.25v-6.25a.625.625 0 0 1 1.25 0v6.25h6.25a.625.625 0 1 1 0 1.25h-6.25v6.25A.624.624 0 0 1 10 17.5"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgPlus);
export default ForwardRef;
